import React from 'react';
import { getCMSObject, TeleScript } from 'sg-ui-components';

const GameOver = () => {
    return (
        <div className='page-info'>
            <div className='description entry-over'>
                <h2 className='text-center'>
                    <TeleScript line={getCMSObject('data.microsite.general.ticketEntry.gameOverMessage.gameOverHeading.contentHTML')} />
                </h2>
                <p className='text-center info my-2'>
                    <TeleScript line={getCMSObject('data.microsite.general.ticketEntry.gameOverMessage.gameOverText.contentHTML')} />
                </p>
            </div>
        </div>
    );
};

export default GameOver;
